<template>
  <label class="radio" :class="{ 'pointer-events-none': disabled }">
    <input
      v-model="value"
      class="radio"
      type="radio"
      :value="radioValue"
      :name="radioName"
      :disabled="disabled"
    />
    <span v-dompurify-html="label"></span>
  </label>
</template>

<script setup lang="ts">
defineProps({
  radioValue: {
    type: [String, Number] as PropType<string | number>,
    required: true,
  },
  label: {
    type: String as PropType<string>,
    required: true,
  },
  radioName: {
    type: String as PropType<string>,
    required: true,
  },
  disabled: {
    type: Boolean as PropType<boolean>,
    required: false,
    default: false,
  },
})

defineEmits(['input'])

const value = defineModel<string>()
</script>

<style lang="scss" scoped>
.radio {
  // css was mainly copied from FIM's Radio component
  display: block;

  span {
    display: inline-block;
    position: relative;
    top: -2px;
    padding: 4px 0 0 2rem;
    cursor: pointer;
    margin-bottom: 0;
    vertical-align: bottom;

    &::after,
    &::before {
      position: absolute;
      content: '';
      border-radius: 50%;
      /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
      transition: all 0.3s ease;
      /* stylelint-disable-next-line plugin/no-low-performance-animation-properties */
      transition-property: transform, border-color;
    }

    &::before {
      left: 0;
      top: 4px;
      width: 24px;
      height: 24px;
      border: 1px solid #d7d7d9;
      background: #f5f6f7;
    }

    &::after {
      transform: scale(0);
      width: 14px;
      height: 14px;
      top: calc(24px / 3 + 1px);
      left: calc(24px / 3 - 3px);
      background: #000000;
    }
  }

  input[type='radio'] {
    display: none;

    &:checked + span::before {
      border-color: #d7d7d9;
    }

    &:checked + span::after {
      transform: scale(1);
    }
  }
}
</style>
